<template>
<ContenedorCampos :titulo="titulo" :isObligatorio="Obligatorio" :error="error">
  <v-col cols="12" lg="6">

    <!-- Paso 1: Fecha -->
    <v-menu
      v-model="showDatePicker"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="fecha"
          label="Seleccione una Fecha"
          hint="YYYY-MM-DD"
          persistent-hint
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="fecha"
        no-title
        @input="showDatePicker = false"
      ></v-date-picker>
    </v-menu>

    <!-- Paso 2: Hora (habilitado solo si hay fecha) -->
    <v-text-field
      v-model="hora"
      label="Seleccione una Hora"
      hint="HH:MM (ej: 14:30)"
      persistent-hint
      prepend-icon="mdi-clock-outline"
      readonly
      :disabled="!fecha"
      @click="dialogHora = true"
    ></v-text-field>

    <HoraGeneral
      v-model="hora"
      :dialog.sync="dialogHora"
    />

  </v-col>
</ContenedorCampos>
</template>

<script>
import ContenedorCampos from '@/components/dinamicos/ContenedorCampos.vue'
import DinamicosMixin from '@/mixins/dinamicosMixin.js'
import HoraGeneral from '@/components/dinamicos/compAuxiliares/HoraGeneral.vue'

export default {
  name: 'FechaHora',
  mixins: [ DinamicosMixin ],
  components: {
    ContenedorCampos,
    HoraGeneral,
  },
  data () {
    return {
      showDatePicker: false,
      dialogHora: false,
      fecha: null,
      hora: null,
    }
  },
  watch: {
    fecha () {
      this._actualizarValor()
    },
    hora () {
      this._actualizarValor()
    }
  },
  methods: {
    _actualizarValor () {
      if (this.fecha && this.hora) {
        this.selectValue = `${this.fecha} ${this.hora}`
      } else {
        this.selectValue = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
